






























































































































































































import Vue, { PropType } from "vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import store from "@/store";
// components
import platformTooltip from "@/features/home/components/platformTooltip.vue";
import PeriodSpecification from "@/features/home/components/PeriodSpecification.vue";
// types
import { Publisher, Client } from "@/features/home/types";
// utils
import * as notifyUtil from "@/commons/utils/notifyUtil";
import { isPeriodSpecification } from "@/features/home/utils";
// enum
import { AuthorityEnum } from "@/features/setting/enums/Authority";
import { PeriodEnum } from "@/commons/enums/Period";

export default Vue.extend({
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
    "platform-tooltip": platformTooltip,
    "period-specification": PeriodSpecification,
  },
  props: {
    publishers: {
      type: Array as PropType<Publisher[]>,
      required: true,
    },
    clients: {
      type: Array as PropType<Client[]>,
      required: true,
    },
    periodInput: { type: Number },
    publishersInput: { type: Array as PropType<number[]> },
    clientsInput: { type: Array as PropType<number[]> },
    startDateInput: { type: String },
    endDateInput: { type: String },
    latestSelectableDate: { type: String },
    fetchData: { type: Function as PropType<() => void>, required: true },
    loading: { type: Boolean, required: true },
  },
  computed: {
    childPeriodInput: {
      // NOTE: computed で getter, setter を使用すると this の型推論ができなくなるケースあり
      get(this: any): number {
        return this.periodInput;
      },
      set(val: number) {
        return this.$emit("update:periodInput", val);
      },
    },
    childStartDateInput: {
      get(this: any): string {
        return this.startDateInput;
      },
      set(val: string) {
        return this.$emit("update:startDateInput", val);
      },
    },
    childEndDateInput: {
      get(this: any): string {
        return this.endDateInput;
      },
      set(val: string) {
        return this.$emit("update:endDateInput", val);
      },
    },
    childPublishersInput: {
      get(): number[] {
        return this.publishersInput;
      },
      set(val: number[]) {
        return this.$emit("update:publishersInput", val);
      },
    },
    childClientsInput: {
      get(): number[] {
        return this.clientsInput;
      },
      set(val: number[]) {
        return this.$emit("update:clientsInput", val);
      },
    },
    periodItems() {
      return PeriodEnum.getListByLanguage();
    },
    loginUser() {
      return store.getters["auth/getLoginUser"];
    },
  },
  methods: {
    handleFetchData() {
      if (this.loading) {
        notifyUtil.notifyErrorMessage(this.$t("general.notify.error.loading"));
      } else {
        this.fetchData();
      }
    },
    canUseReportType(date: string | null) {
      return date !== null;
    },
    isClientUser(userType: number | null): boolean {
      return AuthorityEnum.checkClientByValue(userType);
    },
    isPeriodSpecification(period: number): boolean {
      return isPeriodSpecification(period);
    },
  },
});
